"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.quickLinkComponent = exports.QuickLinkComponent = void 0;
const app_1 = require("app");
class QuickLinkComponent extends app_1.Component {
    constructor() {
        super(...arguments);
        this.selector = '.quick-link-list';
        this.buttonLines = 2;
    }
    BeforeInit() {
        this.buttonCaption = this.el[0].querySelector('.link-button__content-text');
    }
    OnInit() {
        this.buttonCaptionCrop();
    }
    buttonCaptionCrop() {
        $(this.buttonCaption).ellipsis({
            ellipClass: 'ellip',
            lines: this.buttonLines,
            responsive: true,
        });
    }
}
exports.QuickLinkComponent = QuickLinkComponent;
exports.quickLinkComponent = new QuickLinkComponent();
